<div class="filtering-box">
    <nb-select [(selected)]="+selectedItem" (selectedChange)="filterBy()" size="small" status="primary">
        <nb-option *ngFor="let filter of filteringTypes | keyvalue" [value]="+filter.key">{{filter.value | translate}}</nb-option>
    </nb-select>
</div>
